/**
 * Vendens Oto-Slider Logic
 * Handles infinite auto-scroll and typing effect.
 */

class VendensOtoSlider {
    constructor(section) {
        this.section = section;
        this.sectionId = section.id.replace('v-oto-slider-', '');
        this.words = JSON.parse(this.section.dataset.words || '[]');
        this.initTyping();
    }
    // Slider Logic removed in favor of Swiper.js

    initTyping() {
        const typingElement = document.getElementById(`vTypingText-${this.sectionId}`);
        if (!typingElement || this.words.length === 0) return;

        let phraseIndex = 0;
        let charIndex = 0;
        let isDeleting = false;
        let typeSpeed = 150;

        const type = () => {
            const currentPhrase = this.words[phraseIndex];
            
            if (isDeleting) {
                typingElement.textContent = currentPhrase.substring(0, charIndex - 1);
                charIndex--;
                typeSpeed = 30;
            } else {
                typingElement.textContent = currentPhrase.substring(0, charIndex + 1);
                charIndex++;
                typeSpeed = 70 + Math.random() * 50;
            }

            if (!isDeleting && charIndex === currentPhrase.length) {
                isDeleting = true;
                typeSpeed = 1500;
            } else if (isDeleting && charIndex === 0) {
                isDeleting = false;
                phraseIndex = (phraseIndex + 1) % this.words.length;
                typeSpeed = 500;
            }

            setTimeout(type, typeSpeed);
        };

        type();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll('.v-cam-slider-sec');
    sections.forEach(sec => new VendensOtoSlider(sec));
});

// Support Shopify Theme Editor re-renderings
document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.v-cam-slider-sec');
    if (section) new VendensOtoSlider(section);
});
